import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } },
};

const About = () => (
  <section id="about" className="relative bg-white border-t border-slate-200 py-28 sm:py-36">
    <div className="max-w-[1600px] mx-auto px-6 sm:px-10 grid grid-cols-1 lg:grid-cols-12 gap-y-14 gap-x-8">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        variants={fadeUp}
        className="lg:col-span-4"
      >
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#1C8FC4] mb-6">01 / Overview</p>
        <h2 className="font-heading font-bold uppercase text-[#1A2E4A] text-4xl sm:text-5xl tracking-tight leading-[1.05]">
          Built on domain depth, not guesswork.
        </h2>
      </motion.div>

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        variants={fadeUp}
        transition={{ delay: 0.15 }}
        className="lg:col-span-7 lg:col-start-6"
        data-testid="about-content"
      >
        <p
          data-testid="about-sister-company"
          className="font-body text-sm text-slate-500 border-l-2 border-[#D4AF37] pl-5 leading-relaxed"
        >
          SUMATECH INNOVATIONS LLP (Inc. 2023) operates as an end-to-end industrial solutions provider,
          bridging precision product distribution with field-level technical execution across India. Built
          on deep domain knowledge, SUMATECH INNOVATIONS LLP pairs high-performance industrial supply with
          full lifecycle engineering support. SUMATECH INNOVATIONS LLP works alongside its Group Company,
          SUMMIT TECHNODYNE PVT. LTD., sharing decades of combined engineering pedigree across process industries.
        </p>
      </motion.div>
    </div>
  </section>
);

export default About;
